import React from 'react'
import {connect} from 'react-redux'
import Modal from '../common/components/Modal'

import * as actions from '../interview/actions'

const DeleteConfirmModal = ({approveDelete, cancelEdit, show}) => (
  show ? <Modal
    heading="Delete symptom?"
    body="This will clear any symptoms after it."
    buttonClick={approveDelete}
    cancelClick={cancelEdit}
    buttonText="Delete"
  /> : <span/>
)

const mapStateToProps = (state) => ({
  show: state.modals.deleteConfirm.needed
})

const mapDispatchToProps = (dispatch) => ({
  approveDelete: () => dispatch(actions.approveEdit(true)),
  cancelEdit: () => dispatch(actions.cancelEdit())
})

const DeleteConfirmModalWrapper = connect(mapStateToProps, mapDispatchToProps)(DeleteConfirmModal)

export {DeleteConfirmModalWrapper as default, DeleteConfirmModal}



// WEBPACK FOOTER //
// ./assets/modals/DeleteConfirmModal.js